import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { SelectService } from '../services/select.service';
import { TreeSelectDefaultOptions } from '../models/tree-select-default-options';
import { ExpandMode } from '../models/expand-mode';
// tslint:disable-next-line:no-empty
var /** @type {?} */ noop = function () { };
export var /** @type {?} */ CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line:no-forward-ref
    useExisting: forwardRef(function () { return TreeSelectComponent; }),
    multi: true
};
var TreeSelectComponent = /** @class */ (function () {
    /**
     * @param {?} svc
     * @param {?} defaultOpts
     */
    function TreeSelectComponent(svc, defaultOpts) {
        var _this = this;
        this.svc = svc;
        this.defaultOpts = defaultOpts;
        this.onTouchedCallback = noop;
        this.showMoreLink = false;
        this.moreLoaded = false;
        this.disabled = false;
        this.placeholder = '';
        this.filterPlaceholder = 'Type here for filtering items...';
        this.allowFilter = true;
        this._isOpen = false;
        this.onChangeCallback = noop;
        this.haveFocus = false;
        this.inputFocus = false;
        this.clickedOutside = this.clickedOutside.bind(this);
        this.svc.modelChanged$.subscribe(function (result) {
            _this.onChangeCallback(result);
        });
        this.maxVisibleItemCount = (defaultOpts.maxVisibleItemCount || 0);
        this.allowParentSelection = ((defaultOpts.allowParentSelection === undefined ||
            defaultOpts.allowParentSelection === null) ?
            true :
            defaultOpts.allowParentSelection);
        this.allowFilter = ((defaultOpts.allowFilter === undefined || defaultOpts.allowFilter === null) ?
            true :
            defaultOpts.allowFilter);
        this.filterCaseSensitive = ((defaultOpts.filterCaseSensitive === undefined || defaultOpts.filterCaseSensitive === null) ?
            false :
            defaultOpts.filterCaseSensitive);
        this.filterPlaceholder = (defaultOpts.filterPlaceholder || 'Type here for filtering items...');
        this.idField = (defaultOpts.idField || 'id');
        this.textField = (defaultOpts.textField || 'id');
        this.childrenField = (defaultOpts.childrenField || '');
        this.expandMode = (defaultOpts.expandMode || ExpandMode.None);
    }
    Object.defineProperty(TreeSelectComponent.prototype, "items", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this.svc.setItems(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeSelectComponent.prototype, "idField", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this.svc.setConfiguration(function (opt) { return opt.idProperty = value; }, true);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeSelectComponent.prototype, "textField", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this.svc.setConfiguration(function (opt) { return opt.textProperty = value; }, true);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeSelectComponent.prototype, "allowParentSelection", {
        /**
         * @return {?}
         */
        get: function () {
            return this.svc.Configuration.allowParentSelection;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this.svc.setConfiguration(function (opt) { return opt.allowParentSelection = value; }, true);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeSelectComponent.prototype, "restructureWhenChildSameName", {
        /**
         * @return {?}
         */
        get: function () {
            return this.svc.Configuration.restructureWhenChildSameName;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this.svc.setConfiguration(function (opt) { return opt.restructureWhenChildSameName = value; }, true);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeSelectComponent.prototype, "childrenField", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this.svc.setConfiguration(function (opt) { return opt.childProperty = value; }, true);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeSelectComponent.prototype, "multiple", {
        /**
         * @return {?}
         */
        get: function () {
            return this.svc.Configuration.allowMultiple;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this.svc.setConfiguration(function (opt) { return opt.allowMultiple = value; }, true);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeSelectComponent.prototype, "filterCaseSensitive", {
        /**
         * @return {?}
         */
        get: function () {
            return this.svc.Configuration.filterCaseSensitive;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this.svc.setConfiguration(function (opt) { return opt.filterCaseSensitive = value; }, true);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeSelectComponent.prototype, "expandMode", {
        /**
         * @return {?}
         */
        get: function () {
            return this.svc.Configuration.expandMode;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this.svc.setConfiguration(function (opt) { return opt.expandMode = value; }, true);
            this.svc.setExpand();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeSelectComponent.prototype, "maxVisibleItemCount", {
        /**
         * @return {?}
         */
        get: function () {
            return this.svc.Configuration.maxVisibleItemCount;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this.svc.setConfiguration(function (opt) { return opt.maxVisibleItemCount = value; }, true);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeSelectComponent.prototype, "internalItems", {
        /**
         * @return {?}
         */
        get: function () {
            return this.svc.getInternalItems() || [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeSelectComponent.prototype, "selection", {
        /**
         * @return {?}
         */
        get: function () {
            this.showMoreLink = (this.maxVisibleItemCount > 0 &&
                ((this.svc.getInternalSelection().length - this.maxVisibleItemCount) > 0));
            return this.svc.getInternalSelection();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeSelectComponent.prototype, "filter", {
        /**
         * @return {?}
         */
        get: function () {
            return this.svc.Configuration.filter;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this.svc.setConfiguration(function (opt) { return opt.filter = value; }, false);
            for (var _i = 0, _a = this.internalItems; _i < _a.length; _i++) {
                var item = _a[_i];
                this.ProcessMatchFilterTreeItem(item, this.svc.Configuration.filter);
            }
            this.svc.setExpand();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} $event
     * @return {?}
     */
    TreeSelectComponent.prototype.keyUp = function ($event) { };
    /**
     * @param {?} $event
     * @return {?}
     */
    TreeSelectComponent.prototype.toggle = function ($event) {
        $event.preventDefault();
        this.haveFocus = true;
        this.svc.toggleOpen();
    };
    /**
     * @param {?} $event
     * @param {?} item
     * @return {?}
     */
    TreeSelectComponent.prototype.removeItem = function ($event, item) {
        $event.stopPropagation();
        this.svc.toggleItemSelection(item);
    };
    Object.defineProperty(TreeSelectComponent.prototype, "isOpen", {
        /**
         * @return {?}
         */
        get: function () {
            return this.svc.Configuration.isOpen;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    TreeSelectComponent.prototype.clickedOutside = function () {
        if (!this.inputFocus) {
            if (!this.haveFocus && this.isOpen || this.haveFocus && !this.isOpen) {
                this.onTouched();
            }
            this.haveFocus = false;
        }
    };
    /**
     * @return {?}
     */
    TreeSelectComponent.prototype.onTouched = function () {
        this.svc.close();
        this.onTouchedCallback();
    };
    /**
     * @return {?}
     */
    TreeSelectComponent.prototype.setInputFocus = function () {
        this.inputFocus = true;
    };
    /**
     * @return {?}
     */
    TreeSelectComponent.prototype.setInputFocusOut = function () {
        this.inputFocus = false;
    };
    /**
     * Write a new value to the element.
     *
     * \@memberof TreeSelectComponent
     * @param {?} value
     * @return {?}
     */
    TreeSelectComponent.prototype.writeValue = function (value) {
        this.svc.setSelection(value);
    };
    /**
     * Set the function to be called when the control receives a change event.
     *
     * \@memberof TreeSelectComponent
     * @param {?} fn
     * @return {?}
     */
    TreeSelectComponent.prototype.registerOnChange = function (fn) {
        this.onChangeCallback = fn;
    };
    /**
     * Set the function to be called when the control receives a touch event.
     *
     * \@memberof TreeSelectComponent
     * @param {?} fn
     * @return {?}
     */
    TreeSelectComponent.prototype.registerOnTouched = function (fn) {
        this.onTouchedCallback = fn;
    };
    /**
     * This function is called when the control status changes to or from "DISABLED".
     * Depending on the value, it will enable or disable the appropriate DOM element.
     *
     * \@memberof TreeSelectComponent
     * @param {?} isDisabled
     * @return {?}
     */
    TreeSelectComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    /**
     * This finction is called when user click on show more link.
     *
     * \@memberof TreeSelectComponent
     * @param {?} $event
     * @return {?}
     */
    TreeSelectComponent.prototype.loadMore = function ($event) {
        $event.stopPropagation();
        this.moreLoaded = !this.moreLoaded;
    };
    /**
     * @param {?} tree
     * @param {?} filter
     * @return {?}
     */
    TreeSelectComponent.prototype.ProcessMatchFilterTreeItem = function (tree, filter) {
        var /** @type {?} */ result = false;
        if (tree && tree.children && tree.children.length > 0) {
            for (var _i = 0, _a = tree.children; _i < _a.length; _i++) {
                var child = _a[_i];
                result = this.ProcessMatchFilterTreeItem(child, filter) || result;
            }
        }
        if (this.filterFunction && typeof (this.filterFunction) == 'function') {
            tree.matchFilter = this.filterFunction(tree, filter) || result;
            return tree.matchFilter;
        }
        if (typeof (tree.text) == 'object') {
            tree.matchFilter = false;
            return tree.matchFilter;
        }
        tree.matchFilter = this.filterCaseSensitive ?
            (tree.text.indexOf(filter) > -1 ||
                result) :
            (tree.text.toLowerCase().indexOf(filter.toLowerCase()) > -1 ||
                result);
        return tree.matchFilter;
    };
    TreeSelectComponent.decorators = [
        { type: Component, args: [{
                    selector: 'tree-select',
                    templateUrl: './tree-select.component.html',
                    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR, SelectService],
                    styleUrls: ['./tree-select.component.scss']
                },] },
    ];
    /**
     * @nocollapse
     */
    TreeSelectComponent.ctorParameters = function () { return [
        { type: SelectService, },
        { type: TreeSelectDefaultOptions, },
    ]; };
    TreeSelectComponent.propDecorators = {
        'disabled': [{ type: Input },],
        'placeholder': [{ type: Input },],
        'filterPlaceholder': [{ type: Input },],
        'allowFilter': [{ type: Input },],
        'filterFunction': [{ type: Input },],
        'items': [{ type: Input },],
        'idField': [{ type: Input },],
        'textField': [{ type: Input },],
        'allowParentSelection': [{ type: Input },],
        'restructureWhenChildSameName': [{ type: Input },],
        'childrenField': [{ type: Input },],
        'multiple': [{ type: Input },],
        'filterCaseSensitive': [{ type: Input },],
        'expandMode': [{ type: Input },],
        'maxVisibleItemCount': [{ type: Input },],
    };
    return TreeSelectComponent;
}());
export { TreeSelectComponent };
function TreeSelectComponent_tsickle_Closure_declarations() {
    /** @type {?} */
    TreeSelectComponent.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    TreeSelectComponent.ctorParameters;
    /** @type {?} */
    TreeSelectComponent.propDecorators;
    /** @type {?} */
    TreeSelectComponent.prototype.onTouchedCallback;
    /** @type {?} */
    TreeSelectComponent.prototype.showMoreLink;
    /** @type {?} */
    TreeSelectComponent.prototype.moreLoaded;
    /** @type {?} */
    TreeSelectComponent.prototype.disabled;
    /** @type {?} */
    TreeSelectComponent.prototype.placeholder;
    /** @type {?} */
    TreeSelectComponent.prototype.filterPlaceholder;
    /** @type {?} */
    TreeSelectComponent.prototype.allowFilter;
    /** @type {?} */
    TreeSelectComponent.prototype.filterFunction;
    /** @type {?} */
    TreeSelectComponent.prototype._isOpen;
    /** @type {?} */
    TreeSelectComponent.prototype.onChangeCallback;
    /** @type {?} */
    TreeSelectComponent.prototype.haveFocus;
    /** @type {?} */
    TreeSelectComponent.prototype.inputFocus;
    /** @type {?} */
    TreeSelectComponent.prototype.svc;
    /** @type {?} */
    TreeSelectComponent.prototype.defaultOpts;
}
//# sourceMappingURL=tree-select.component.js.map


//////////////////
// WEBPACK FOOTER
// ./.tmp/custom-tree-select/src/components/tree-select.component.js
// module id = 40
// module chunks = 0